import type { GenerateQrRequest, GenerateQrResponse } from '@pulsify/shared/dto'
import { adminBypassHeaders } from '~/app/admin-bypass'
import { api, getAuthToken, unwrap } from '~/shared/lib/rpc'

export const qrApi = {
  async generate(
    businessId: string,
    params: GenerateQrRequest,
    logo?: File | null,
  ): Promise<GenerateQrResponse> {
    const url = api.api.businesses[':businessId']['ai-studio'].qr.$url({
      param: { businessId },
    })
    const formData = new FormData()
    formData.append('params', JSON.stringify(params))
    if (logo) formData.append('logo', logo)
    const token = await getAuthToken()
    const headers: Record<string, string> = { ...adminBypassHeaders() }
    if (token) headers.Authorization = `Bearer ${token}`
    const res = await fetch(url, { method: 'POST', body: formData, headers })
    return unwrap<GenerateQrResponse>(res)
  },
}
